/**
 * screenRoutes — mapeamento bidirecional entre screen-keys do protótipo e rotas
 * do react-router-dom.
 *
 * O protótipo navega por estado: navigate('dashboard'), navigate('liveboard'), etc.
 * O shim NavigationContext preserva esse contrato enquanto conecta ao router.
 *
 * Adicione novas telas aqui conforme as ondas F0-FE-3+ forem portadas.
 */

/** @type {Record<string, string>} screen-key → path */
export const SCREEN_TO_PATH = {
  // Autenticação (F0-FE-2 adiciona OIDC real)
  login: '/login',

  // App
  dashboard:   '/dashboard',
  project:     '/project',
  workflows:   '/workflows',
  catalog:     '/catalog',
  agentRoom:   '/agents/room',
  agentSuggest:'/agents/sugestao',
  agentObservability: '/agents/observabilidade',
  grafo:       '/grafo',
  history:     '/history',
  contextAudit: '/context-audit',
  assistant:   '/assistant',
  usage:       '/usage',
  settings:    '/settings',
  accessMatrix:'/settings/access-matrix',
  stepPrompts: '/settings/step-prompts',

  // Jornada
  journey:       '/journey',
  designStudio:  '/journey/design-studio',
  designer:      '/journey/designer',

  // Quality Gates
  gateNegocio:   '/gates/negocio',
  gateTecnologia:'/gates/tecnologia',
  gateSquads:    '/gates/squads',
  gateEscopo:    '/gates/escopo',
  gates:         '/gates',
  gateB:         '/gates/b',
  gateFinal:     '/gates/final',

  // Execução
  liveboard:     '/execution/liveboard',
  missionControl:'/execution/mission-control',
  deliveryCheck: '/execution/delivery-check',
  failure:       '/execution/failure',
  output:        '/execution/output',
};

/** @type {Record<string, string>} path → screen-key (inverso) */
export const PATH_TO_SCREEN = Object.fromEntries(
  Object.entries(SCREEN_TO_PATH).map(([k, v]) => [v, k]),
);

/**
 * Dado um path do router, devolve a screen-key correspondente.
 * Fallback: 'dashboard'.
 */
export function pathToScreen(path) {
  return PATH_TO_SCREEN[path] ?? 'dashboard';
}

/**
 * Dado uma screen-key, devolve o path do router.
 * Fallback: '/dashboard'.
 */
export function screenToPath(screen) {
  return SCREEN_TO_PATH[screen] ?? '/dashboard';
}
